import React from "react";

const InfoCard = ({ className = "", bgColor = "#F6F6F8", icon, title, content }) => (
    <div className={`info-card p-5 mb-6 border-radius ${className}`} style={{ backgroundColor: bgColor }}>
        {icon && <div className="mb-2">{icon}</div>}
        {title && <h4 className="mt-0 mb-3">{title}</h4>}
        {content && <p className="text-16 mb-0">{content}</p>}
    </div>
);

export default InfoCard;
